import { Modal, Button } from "react-bootstrap";
import { removeBookmarkIcon } from "../../constants/icons";

function RemoveBookmark({ show, removeBookHandle, desc, title }) {
    return (
        <Modal className="common-modal remove-bookmark-modal" show={show} onHide={removeBookHandle} centered>
            <Modal.Body>
                <h5 className="modal-question">{title}</h5>
                <p>{desc}</p>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="light" onClick={removeBookHandle}>
                    Cancel
                </Button>
                <Button variant="primary" onClick={removeBookHandle}>{removeBookmarkIcon}Remove bookmark</Button>
            </Modal.Footer>
        </Modal>
    );
}

export default RemoveBookmark;
